<template>
  <div class="picker">
    <h1 class="ui center aligned header">
      Kies een filmpje {{ activePlayer.name }}:
    </h1>
    <div class="ui hidden divider"></div>
    <div :class="cssClass">
      <div
        class="column center aligned"
        v-for="(question, questionId) in questions"
        :key="questionId"
      >
        <img
          class="ui fluid rounded glowing image"
          :data-video-id="questionId"
          :class="{ disabled: hasBeenPicked(questionId) }"
          :src="
            question.thumbnail || `@/assets/placeholder-${questionId + 1}.png`
          "
          @click.once="
            isHost &&
              !hasBeenPicked(questionId) &&
              pickQuestion({ questionId, playerId: activePlayer.id })
          "
        />
        <h1 class="ui header" v-if="isHost">[ {{ keys[questionId] }} ]</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { nrToWord } from '@/filters';
import { includes as _includes } from 'lodash';
import Mousetrap from 'mousetrap';
import { KEYBOARD_KEYS } from '@/config';

export default {
  name: 'pick-question',
  data() {
    return {
      keys: KEYBOARD_KEYS
    };
  },
  computed: {
    ...mapGetters(['isHost']),
    activePlayer() {
      return this.$store.getters.activePlayer;
    },
    questions() {
      return this.$store.getters['openDeur/questions'];
    },
    cssClass() {
      return `ui ${nrToWord(this.questions.length)} column stackable grid`;
    }
  },
  created() {
    this.addKeyboardShortcuts();
  },
  methods: {
    hasBeenPicked(questionId) {
      return _includes(
        this.$store.state.rounds.openDeur.pickedQuestions,
        questionId
      );
    },
    pickQuestion(pickedQuestion) {
      this.$store.dispatch('openDeur/pickQuestion', pickedQuestion);
      this.$store.dispatch('syncGame');
    },
    addKeyboardShortcuts() {
      Mousetrap.bind(this.keys, e => {
        const index = this.keys.indexOf(e.key);
        // -> add qwerty & numeric support
        const videoId = index > 9 ? index - Math.floor(index / 10) * 10 : index;
        const videoButton = document.querySelector(
          `[data-video-id='${videoId}']`
        );
        if (videoButton) videoButton.click();
        return false;
      });
    }
  }
};
</script>

<style scoped>
img {
  cursor: pointer;
}
.ui.header {
  font-size: 3rem;
}
</style>
